import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=ce5a9a4a&scoped=true"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"
import style0 from "./order_list.vue?vue&type=style&index=0&id=ce5a9a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5a9a4a",
  null
  
)

export default component.exports